var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_9859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43934 14.6667H12C12.3536 14.6667 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3333 13.6869 13.3333 13.3333V5.33332C13.3339 5.12206 13.2925 4.91279 13.2117 4.71758C13.131 4.52237 13.0123 4.3451 12.8627 4.19598L10.4707 1.80398C10.3216 1.65433 10.1443 1.53569 9.94907 1.45491C9.75387 1.37412 9.5446 1.3328 9.33333 1.33332H4C3.64638 1.33332 3.30724 1.47379 3.05719 1.72384C2.80714 1.97389 2.66667 2.31303 2.66667 2.66665V8.89332",
    stroke: "#7E4ED7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 1.33331V4.66629C9.33334 4.84308 9.40357 5.01264 9.52858 5.13765C9.65359 5.26266 9.82314 5.33289 9.99993 5.33289H13.3329",
    stroke: "#7E4ED7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91822 8.41461C7.18367 8.14942 7.5436 8.00055 7.91882 8.00073C8.29404 8.00092 8.65381 8.15016 8.919 8.41561C9.18419 8.68106 9.33307 9.04099 9.33288 9.41621C9.33269 9.79143 9.18346 10.1512 8.918 10.4164L5.57302 13.7574C5.41463 13.9159 5.21884 14.0319 5.00375 14.0947L3.09262 14.6526C3.03526 14.6693 2.97446 14.6703 2.91658 14.6555C2.8587 14.6407 2.80587 14.6106 2.76362 14.5683C2.72137 14.5261 2.69126 14.4732 2.67643 14.4154C2.6616 14.3575 2.6626 14.2967 2.67933 14.2393L3.23661 12.3269C3.29952 12.112 3.41551 11.9165 3.5739 11.7583L6.91822 8.41461Z",
    stroke: "#7E4ED7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_9859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePencil);
export default __webpack_public_path__ + "static/media/file-pencil.e0fedf17.svg";
export { ForwardRef as ReactComponent };